import { CardsTableEmptyPlaceholder } from './CardsTableEmptyPlaceholder';
export default CardsTableEmptyPlaceholder;
